module.exports = __webpack_public_path__ + "static/media/arrow-left-black.4cdb1678.svg";